import { USERINFO_LOAD_SUCCESS } from '../store/userinfo'
import { PROJECT_LOAD_SUCCESS } from '../store/project'

export const CAT_UI_ACTION = 'UI Action'
export const CAT_EVENT_STREAM_ACTION = 'Event Stream Action'

export const ACTION_LANE_HELP_OPENED = 'Lane Help Opened'

export const ENTERPRISE_ID_DIMENSION_ID = 'dimension1'
export const USER_ID_DIMENSION_ID = 'dimension2'
export const ENTERPRISE_DIMENSION_ID = 'dimension3'
export const PERSONA_RESOURCE_KEY_ID = 'dimension4'
export const PROJECT_ID_DIMENSION_ID = 'dimension5'

export class GAEventTracker {
  constructor(ga) {
    this.ga = ga
  }

  trackEvent(category, name, label) {
    this.ga('send', {
      hitType: 'event',
      eventAction: name,
      eventCategory: category,
      eventLabel: label
    })
  }

  setDimension(dimensionId, value) {
    this.ga('set', dimensionId, value)
  }
}

export const googleAnalyticsMiddleware = eventTracker => {
  return store => next => action => {
    if (action.type === USERINFO_LOAD_SUCCESS) {
      eventTracker.setDimension(ENTERPRISE_ID_DIMENSION_ID, action.payload.enterpriseId);
      eventTracker.setDimension(ENTERPRISE_DIMENSION_ID, action.payload.enterpriseName);
      eventTracker.setDimension(USER_ID_DIMENSION_ID, action.payload.id);
      eventTracker.setDimension(PERSONA_RESOURCE_KEY_ID, action.payload.personaResourceKey);
    }

    if (action.type === PROJECT_LOAD_SUCCESS) {
      eventTracker.setDimension(PROJECT_ID_DIMENSION_ID, action.payload.id);
    }

    eventTracker.trackEvent(CAT_EVENT_STREAM_ACTION, action.type)
    return next(action)
  }
}



// WEBPACK FOOTER //
// ./src/util/googleAnalytics.js